import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, isDevMode } from '@angular/core';
import { Router } from '@angular/router';

export function debugInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    let newReq: HttpRequest<unknown> | undefined;
    const router = inject(Router);

    if (isDevMode()) {
        if (req.url.includes('/datamart/querycount/qc') && router.url.includes('record-selection?debug=true')) {
            console.log('hit');
            newReq = req.clone({
                url: req.url + '?error=true&httpStatus=400',
            });
        } else {
            newReq = req;
        }
    } else {
        newReq = req;
    }

    return next(newReq);
}
